import { render, staticRenderFns } from "./CodeIpnut.vue?vue&type=template&id=835b28a6&scoped=true&"
import script from "./CodeIpnut.vue?vue&type=script&lang=js&"
export * from "./CodeIpnut.vue?vue&type=script&lang=js&"
import style0 from "./CodeIpnut.vue?vue&type=style&index=0&id=835b28a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835b28a6",
  null
  
)

export default component.exports